<template>
  <div id="BattleDialog">
    <el-dialog
      v-if="visible"
      class="sQDialog"
      top="30vh"
      :visible.sync="visible"
      :show="visible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="closeOnClickModal"
      append-to-body>
      <div class="alertBox">
        <div class="tipTitle">
          {{tipTitle}}
        </div>
        <div class="content" :class="tipTitle ? 'content1' : ''">
          {{content}}
        </div>
        <slot name="contentMy"></slot>
        <div class="btnBox">
          <div class="confirm cursor" @click="yesBtn">{{ okTxt }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 1000
    },
    hasCloseIcon: { type: Boolean, default: true },
    top: {
      type: [String, Number],
      default: '100px'
    },
    // show: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: false }
    // type: {
    //   type: Number, default: 1
    // }
  },
  name: 'BattleDialog',
  data () {
    return {
      visible: false,
      content: '',
      tipTitle: '',
      confirm: null,
      type: 1,
      okTxt: 'OK',
      cancelTxt: 'Cancel',
      cancel: null
    }
  },
  methods: {
    noBtn () {
      this.cancel && this.cancel()
      this.visible = false
    },
    yesBtn () {
      this.confirm && this.confirm()
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
$width: 100vw/1920;
 /deep/ .el-dialog{
  width: 650*$width;
  width: 650*$width;
  height: 370*$width;
  background-image: url('https://img.webloom.cn/img/SQDig.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 20*$width;
}
/deep/ .el-dialog__header{
  display: none;
}
/deep/ .el-dialog__body{
  box-sizing: border-box;
  padding: 40*$width;
}
.sQDialog{
  .alertBox{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    color: #FFFFFF;
    .tipTitle{
      font-size: 22*$width;
      padding-top: 10*$width;
    }
    .content{
      padding-top: 44*$width;
      width: fit-content;
      max-width: 432*$width;
      font-size: 18*$width;
      line-height: 24*$width;
      padding-bottom: 50*$width;
      word-break: break-word;
    }
    .content1{
      padding-top: 30*$width;
      word-break: break-word;
    }
    .btnBox{
        cursor: pointer;
        width: 260*$width;
        height: 48*$width;
        font-size: 18*$width;
        background: linear-gradient(270deg, #FFBB2E 0%, #FF6324 100%);
        border-radius: 5*$width;
        text-align: center;
        line-height: 48*$width;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugin/SQDialog/src/main.vue